import { jsx } from 'react/jsx-runtime';
import { styled, Typography } from '@mui/material';

function ActionBarLabel({ children, "data-testid": dataTestId }) {
    return (jsx(Wrapper, { children: jsx(LabelTypography, { "data-testid": dataTestId, children: children }) }));
}
const LabelTypography = styled(Typography)({
    fontSize: 14,
    lineHeight: "20px",
});
const Wrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(0, 2),
}));

export { ActionBarLabel };
//# sourceMappingURL=ActionBarLabel.js.map
